import { FC, ChangeEvent, useEffect, useState } from 'react';
import { IconButton, InputBase, SearchIcon, TrashIcon, ClearIcon } from '../../uiLibraryImports';
import UseSearchDebounce from './useSearchDebounce';
import globalColors from '../globalColors';

const Search: FC<SearchProps> = (props: SearchProps) => {
    const {
        backgroundColor = 'white',
        width,
        placeholder,
        firstString,
        onSearchChange,
        outerString,
        useTrashIcon,
        inputColor = globalColors.texts.inputText
    } = props;
    const [search, setSearch] = UseSearchDebounce();
    const [searchString, setSearchString] = useState<string>('');

    useEffect(() => {
        onSearchChange((search as any) || '');
    }, [search]);

    useEffect(() => {
        setSearch?.((searchString as any) || '');
    }, [searchString]);

    useEffect(() => {
        if (outerString !== searchString) setSearchString?.(outerString as any);
    }, [outerString]);

    return (
        <InputBase
            sx={{
                width: width || '17rem',
                height: '2.3rem',
                flex: 1,
                background: backgroundColor,
                border: `1px solid ${globalColors.borders.input}`,
                borderRadius: '4px',
                input: { color: inputColor }
            }}
            value={searchString}
            placeholder={placeholder}
            inputProps={{ 'aria-label': placeholder }}
            onChange={(event: ChangeEvent<HTMLInputElement>) => setSearchString?.(event.target.value as any)}
            startAdornment={
                firstString ? (
                    <div
                        style={{
                            width: 'max-content',
                            background: 'linear-gradient(0deg, #EFE9FB 0%, #EFE9FB 100%), #FFF',
                            borderRadius: '4px',
                            color: inputColor,
                            padding: '0.2rem',
                            marginLeft: '0.5rem',
                            marginRight: '0.5rem'
                        }}
                    >
                        {firstString}
                    </div>
                ) : (
                    <SearchIcon fontSize="medium" sx={{ margin: '0.5rem', color: inputColor }} />
                )
            }
            endAdornment={
                <div>
                    {searchString !== '' && (
                        <IconButton
                            color="primary"
                            aria-label="directions"
                            onClick={() => setSearchString?.('' as any)}
                            sx={{ padding: 0 }}
                        >
                            <ClearIcon fontSize="medium" sx={{ margin: '0.5rem', color: inputColor }} />
                        </IconButton>
                    )}
                    {useTrashIcon && (
                        <IconButton
                            color="primary"
                            aria-label="directions"
                            onClick={() => setSearchString?.('' as any)}
                            sx={{ padding: 0 }}
                        >
                            <TrashIcon fontSize="medium" sx={{ margin: '0.5rem', color: inputColor }} />
                        </IconButton>
                    )}
                </div>
            }
        />
    );
};

export interface SearchProps {
    firstString?: string;
    placeholder: string;
    onSearchChange: (search: string) => void;
    useTrashIcon?: boolean;
    width?: string;
    outerString?: string;
    backgroundColor?: string;
    inputColor?: string;
}

export default Search;
